module.exports = __webpack_public_path__ + "assets/img/siding-6.2a333e0b.jpg";